//TODO: Traducir el resto de rutas, solo se realizan las necesarias para APPLICATIONS
const router = {
  //Rutas relacionadas a los flujos
  teams: "/equipos",
  team_assignement: "/integrantes-equipos",
  protocols: "/protocolos",
  protocolo_tareas: "/protocolos/tareas",
  cases: "/cases/",
  case_new: "/cases/new",
  case_draft: "/cases/drafts",
  case_tasks: "/tareas",
  case_task_new: "/tareas/nuevo",
  workflow: "/pendings",
  admin_tasks: "/admin-tasks",

  // Formularios
  form_generator: "/formularios/",
  form_generator_new: "/formularios/nuevo",
  // Configuración
  aplicativo: "/configuracion/",
  app: "/configuracion/app",

  // Maestros
  maestros: "/main",
  definiciones: "/main/definiciones",
  departamentos: "/main/departamentos",
  municipios: "/main/municipios",
  funciones: "/main/funciones",
  
  // Maestros ACL
  acl_actions: "/main/acl_acciones/",
  acl_object_types: "/main/acl_objetos/",
  acl_roles: "/main/acl_roles/",
  acl_rules: "/main/acl_reglas/",
  acl_users: "/acl/users",
  acl_entidades: "/acl/registro-entidad",

  profile: "/profile",
  login: "/login/",
  home: "/home",
  validacion_qr: "/validacion",
  reportes: "/reportes",
  facturas: "/unimarka/facturas",
  notas: "/unimarka/notas/",
  error_acl_target: "/home",
  //Editor de plantillas
  plantillas_editor: "/editor-plantillas",
  plantillas_editor_pdf: "/editor-plantillas",
  plantillas_editor_inicio: "/editor-plantillas",
  plantillas_formularios: "/cases/form_templates",
  preliquidacion: "/preliquidacion",
  contratos: "/contratos",
  depreciacion: "/procesos/depreciacion",
  reports: "/reports",
  reports_v2: "/reports-v2",
  new_template: "/templates/new_template",
  error: "/404",
  // Citas
  actividades: "/turnos/actividades",
  crear_turnos: "/turnos/crear-turnos",
  ver_turnos: "/turnos/ver-turnos",
  // Integraciones
  integraciones: "/configuracion/integraciones",
  reprocesos: "/configuracion/reprocesos",
  integracion_pos: "/configuracion/integracion-pos",
  sincronizar_resoluciones: "/configuracion/sincronizar-resoluciones"
};

export default router;
